import { generateId } from '@freelancer/datastore/testing';
import {
  ContextTypeApi,
  SourceTypeApi,
} from 'api-typings/messages/messages_types';
import { Bid } from '../bids/bids.model';
import { Thread } from '../threads/threads.model';
import { Message, MessageSendStatus } from './messages.model';

export interface GenerateMessageOptions {
  readonly thread: Thread;
  readonly fromUserId: number;
  readonly bid?: Bid;
}

export function generateAwardProjectRichMessage(
  options: GenerateMessageOptions,
): Message {
  if (options.thread.context.type !== ContextTypeApi.PROJECT) {
    throw new Error('Thread does not belong to a project context.');
  }
  if (options.bid === undefined) {
    throw new Error('Bid is required to award a project');
  }
  return {
    id: generateId(),
    attachments: [],
    fromUser: options.fromUserId,
    message: `You've been awarded! This project has a budget of $300.00 USD and you will be charged a project commission of $30.00 USD. To accept click here https://www.syd1.fln-dev.net/projects/${options.thread.context.id}.html`,
    messageSource: SourceTypeApi.BOT,
    richMessage: {
      category: `ACCEPT_CTA_${options.thread.context.id}`,
      long: [
        [
          {
            text: 'Congratulations, your bid has been awarded!',
            type: 'heading',
          },
        ],
        [
          {
            text: 'Click the Accept button below to start working.',
            type: 'body',
          },
        ],
        [
          {
            text:
              'This project has a budget of $300.00 USD and you will be charged a project commission of $30.00 USD.',
            style: 'small',
            type: 'body',
          },
        ],
        [
          {
            action: 'PATCH',
            type: 'button',
            label: 'Accept',
            request: {
              url: `https://www.syd1.fln-dev.net/api/projects/0.1/bids/${options.bid.id}/`,
              payload: { action: 'ACCEPT' },
              contentType: 'application/x-www-form-urlencoded',
            },
            displayType: 'green',
          },
        ],
      ],
      short: [],
      email: {
        text: `Follow the link below to accept this project and start working!<br/><br/>https://www.syd1.fln-dev.net/api/projects/0.1/bids/${options.bid.id}/`,
        type: 'email-copy',
        heading: 'Congratulations, your bid has been awarded!',
      },
    },
    threadId: options.thread.id,
    timeCreated: Date.now(),
    sendStatus: MessageSendStatus.SENDING,
  };
}
